import React from 'react';
import { 
// CustomerLoyaltyAppProvider,
RewardsAndOffersProvider, AvailablePerksProvider, InfoPerksProvider, InfoOffersProvider, InfoRewardsProvider, PerksRedeemProvider, NationalAccountProvider, ChallengesProvider, DrawerProvider, PricingProvider, } from '../../../contexts';
var AllProviders = function (_a) {
    var children = _a.children;
    return (React.createElement(RewardsAndOffersProvider, null,
        React.createElement(AvailablePerksProvider, null,
            React.createElement(InfoPerksProvider, null,
                React.createElement(InfoOffersProvider, null,
                    React.createElement(PerksRedeemProvider, null,
                        React.createElement(NationalAccountProvider, null,
                            React.createElement(ChallengesProvider, null,
                                React.createElement(React.Fragment, null, children)))))))));
};
var PricingBenefitsProviders = function (_a) {
    var children = _a.children;
    return (React.createElement(RewardsAndOffersProvider, null,
        React.createElement(React.Fragment, null, children)));
};
var PricingBooksProviders = function (_a) {
    var children = _a.children;
    return (React.createElement(RewardsAndOffersProvider, null,
        React.createElement(React.Fragment, null, children)));
};
var PerksPageProviders = function (_a) {
    var children = _a.children;
    return (React.createElement(InfoPerksProvider, null,
        React.createElement(PerksRedeemProvider, null,
            React.createElement(PricingProvider, { shouldShowPricingBookPage: false },
                React.createElement(React.Fragment, null, children)))));
};
var RewardsHubProviders = function (_a) {
    var children = _a.children;
    return (React.createElement(RewardsAndOffersProvider, null,
        React.createElement(InfoPerksProvider, null,
            React.createElement(AvailablePerksProvider, null,
                React.createElement(InfoOffersProvider, null,
                    React.createElement(ChallengesProvider, null,
                        React.createElement(InfoRewardsProvider, null,
                            React.createElement(PerksRedeemProvider, null,
                                React.createElement(DrawerProvider, null,
                                    React.createElement(React.Fragment, null, children))))))))));
};
export var PageProviders = function (_a) {
    var children = _a.children, page = _a.page;
    var ChildProviders = React.createElement(AllProviders, null, children);
    switch (page) {
        case 'PricingBenefitsPage':
            ChildProviders = (React.createElement(PricingBenefitsProviders, null, children));
            break;
        case 'PricingBooksPage':
            ChildProviders = (React.createElement(PricingBooksProviders, null, children));
            break;
        case 'PerksPage':
            ChildProviders = React.createElement(PerksPageProviders, null, children);
            break;
        case 'RewardsHubPage':
            ChildProviders = React.createElement(RewardsHubProviders, null, children);
            break;
        default:
            break;
    }
    return React.createElement(React.Fragment, null, ChildProviders);
};
